/* Burnout Club : tailles, pièces restantes, quantités du panier */
(function () {
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  document.querySelectorAll('[data-bcx-achat]').forEach(function (f) {
    var tailles = f.querySelector('[data-bcx-tailles]');
    var champ = f.querySelector('[data-bcx-variante]');
    var stock = f.querySelector('[data-bcx-stock]');
    var bouton = f.querySelector('[data-bcx-bouton]');
    var total = parseInt(f.dataset.total, 10) || 0;
    var restant = parseInt(f.dataset.restant, 10) || 0;
    var suivi = f.dataset.suivi === 'true';
    var choisi = null;
    if (f.dataset.langue) EN = f.dataset.langue === 'en';
    function montrer() {
      if (!suivi) return;
      stock.hidden = false;
      if (choisi && choisi.dataset.stock !== '') {
        var n = parseInt(choisi.dataset.stock, 10);
        stock.innerHTML = '<span>' + (EN ? 'Size ' : 'Taille ') + choisi.dataset.taille + '</span><span class="' + (n < 10 ? 'bcx-peu' : '') + '">' + n + (EN ? (n > 1 ? ' pieces left' : ' piece left') : (n > 1 ? ' pièces restantes' : ' pièce restante')) + '</span>';
      } else {
        stock.innerHTML = '<span>' + (EN ? 'Series 1' : 'Série 1') + '</span><span>' + restant + (total ? '/' + total : '') + (EN ? ' pieces left' : ' pièces restantes') + '</span>';
      }
    }
    if (tailles) {
      tailles.addEventListener('click', function (e) {
        var b = e.target.closest('.bcx-taille');
        if (!b || b.disabled) return;
        choisi = b;
        champ.value = b.dataset.id;
        tailles.querySelectorAll('.bcx-taille').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        tailles.classList.remove('bcx-secoue');
        bouton.textContent = bouton.dataset.libelle + (EN ? ' · size ' : ' · taille ') + b.dataset.taille;
        montrer();
      });
    }
    /* Livraison en courant : un créneau facultatif, ajouté au panier avec le t-shirt */
    var courant = f.querySelector('[data-bcx-courant]'), creneau = null;
    if (courant) {
      courant.addEventListener('click', function (e) {
        var c = e.target.closest('.bcx-creneau');
        if (!c || c.disabled) return;
        creneau = (creneau === c) ? null : c;
        courant.querySelectorAll('.bcx-creneau').forEach(function (x) { x.setAttribute('aria-pressed', x === creneau); });
      });
    }
    f.addEventListener('submit', function (e) {
      if (!champ.value) {
        e.preventDefault();
        montrer();
        if (tailles) tailles.classList.add('bcx-secoue');
        bouton.textContent = EN ? 'Choose a size' : 'Choisir une taille';
        return;
      }
      if (creneau && window.fetch) {
        e.preventDefault();
        bouton.disabled = true;
        var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(racine + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: parseInt(champ.value, 10), quantity: 1 },
            { id: parseInt(creneau.dataset.id, 10), quantity: 1 }
          ] })
        }).then(function (r) {
          if (r.ok) { window.location.href = racine + 'cart'; return; }
          bouton.disabled = false;
          var err = courant.querySelector('[data-bcx-courant-err]');
          err.textContent = EN ? 'This slot was just taken. Choose another slot, or pre-order without one.' : 'Ce créneau vient d\u2019être pris. Choisir un autre créneau, ou précommander sans.';
          err.hidden = false;
          creneau.disabled = true; creneau.setAttribute('aria-pressed', 'false'); creneau = null;
        }).catch(function () { bouton.disabled = false; f.submit(); });
      }
    });
  });
  document.querySelectorAll('[data-bcx-qte]').forEach(function (q) {
    var input = q.querySelector('input');
    q.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pas]');
      if (!b) return;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.pas, 10));
      input.form.submit();
    });
  });
  var bande = document.querySelector('[data-bcx-defile]'), compteur = document.querySelector('[data-bcx-compteur]');
  if (bande && compteur) {
    var n = bande.children.length;
    bande.addEventListener('scroll', function () {
      var w = bande.firstElementChild.getBoundingClientRect().width + 6;
      compteur.textContent = String(Math.round(bande.scrollLeft / w) + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
    }, { passive: true });
  }
})();
